import React, {useEffect, useState} from 'react'
import {PortableText} from '@portabletext/react'
import {sanity} from '../lib/sanity'

const PRIVACY_QUERY = `*[_type == "privacyPage"][0]{
  title,
  lastUpdated,
  body
}`

const portableTextComponents = {
  block: {
    h2: ({children}) => (
      <h2 className="mt-12 mb-4 text-2xl font-sans_bold">
        {children}
      </h2>
    ),
    h3: ({children}) => (
      <h3 className="mt-8 mb-3 text-xl font-sans_bold">
        {children}
      </h3>
    ),
    normal: ({children}) => (
      <p className="mb-5 text-lg font-sans leading-tight">
        {children}
      </p>
    ),
  },
  list: {
    bullet: ({children}) => (
      <ul className="mb-6 list-disc space-y-2 pl-6 text-lg font-sans leading-tight">
        {children}
      </ul>
    ),
    number: ({children}) => (
      <ol className="mb-6 list-decimal space-y-2 pl-6 text-lg font-sans leading-tight">
        {children}
      </ol>
    ),
  },
  marks: {
    link: ({children, value}) => {
      const href = value?.href || '#'
      const isExternal = href.startsWith('http')

      return (
        <a
          href={href}
          target={isExternal ? '_blank' : undefined}
          rel={isExternal ? 'noopener noreferrer' : undefined}
          className="underline decoration-[#5757fd]/40 underline-offset-4 hover:decoration-[#5757fd]"
        >
          {children}
        </a>
      )
    },
  },
}

function PrivacyPage() {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    sanity
      .fetch(PRIVACY_QUERY)
      .then((result) => {
        setPage(result)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  if (loading) return null

  if (!page) {
    return (
      <main className="min-h-screen text-[#5757fd]">
        <section className="mx-auto max-w-3xl px-8 py-24 md:py-36">
          <p className="text-lg font-sans">Geen privacyverklaring gevonden.</p>
        </section>
      </main>
    )
  }

  return (
    <main className="min-h-screen text-[#5757fd]">
      <section className="mx-auto max-w-3xl px-8 py-24 md:py-36">
        <div className="mb-16">
          <h1 className="text-5xl font-sans_bold leading-[0.95] tracking-tight md:text-7xl">
            {page.title}
          </h1>

          {page.lastUpdated && (
            <p className="mt-6 text-sm font-sans text-[#5757fd]/70">
              Laatst bijgewerkt: {new Intl.DateTimeFormat('nl-NL', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              }).format(new Date(page.lastUpdated))}
            </p>
          )}
        </div>

        <div className="rounded-[2rem] bg-white/60 p-6 md:p-10">
          <PortableText
            value={page.body}
            components={portableTextComponents}
          />
        </div>
      </section>
    </main>
  )
}

export default PrivacyPage